export const locales = {
  'ru': 'ru-RU',
  'en': 'en-US'
}
